import React from 'react';
import { Overlay } from '../widgets';
import { useOrganization } from './context/OrganizationContext';


const ThemeBox = ({ themeConfig, handleChange, state }) => {
    const { theme_id, theme_config, theme_name } = themeConfig || {};
    const { themeId } = state;

    const handleSelect = (selected) => {
        handleChange({ ...state, themeId: selected });
    }
    const getBackgroundColor = (theme_config) => ((theme_config || {}).primary || {}).main || 'transparent';

    return (
        <Overlay title={theme_name}>
            <span
                key={theme_id}
                onClick={() => handleSelect(theme_id)}
                className={`org-theme ${themeId === theme_id ? 'active' : ''}`}
                style={{ backgroundColor: getBackgroundColor(theme_config) }}
            >
                {themeId === theme_id ? <i className="fa fa-check" aria-hidden="true"></i> : null}
            </span>
        </Overlay>
    );
}

const Theme = () => {
    const { organizationState: state, setOrganizationState: handleChange, themeConfigData } = useOrganization();

    return (
        <div className="org-theme-container">
            {themeConfigData.map(themeConfig => (
                <ThemeBox key={themeConfig.theme_id} state={state} handleChange={handleChange} themeConfig={themeConfig} />
            ))}
        </div>
    );
}

export default Theme;
